import React from "react";
import { connect } from "react-redux";
import { numberWithCommas } from '$Deposits/lib/LibCommonData'
import { SetDepositMoneyStatus } from '$Deposits/store/actions/DepositAction'
import translate from "../../../../../Main/lib/translate/TranslateJs";
const width = 100;
const height = 100;

class InputItem extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isPasswordVisible:false
        };
    }

    componentDidUpdate(prevProps, prevState) {

    }
    componentDidMount() {

    }
    componentWillUnmount() {

    }

    render() {
        const {isPasswordVisible} = this.state;
        const {
            stateVal = '',
            onChange = () => {},
            placeholder = '',
            value = '',
            title,
            maxLength = 50,
            extra,
            MethodCodeActive,
            // InvoiceExchangerate
        } = this.props
        const isPasswordType = title.includes("PIN")
        return (
            <>
                <p className="inputTitle">{title}</p>
                <div className={'input-item-wrap ' + (stateVal ? 'inputErr' : '')} >
                    <input
                        className={title.includes('Số Tham Chiếu') && 'depositDatePicker'}
                        value={value}
                        placeholder={placeholder}
                        onChange={(e) => {onChange(e.target.value) }}
                        autoComplete={'initial'}
                        maxLength={maxLength}
                        type={!isPasswordType ? "text" : isPasswordVisible ? "text" : "password"}
                    />
                    {
                        isPasswordType && (
                            <div 
                                onClick={()=>{this.setState(prevState=> {return {...prevState, isPasswordVisible: !prevState.isPasswordVisible}})}} 
                                className={`eyeIcon ${isPasswordVisible ? "visibleIcon" :"invisibleIcon"}`}
                            />
                        )
                    }
                </div>
                {
                    stateVal &&
                    <div className='inputErrMsg'>
                        {stateVal}
                    </div>
                }

                {title.includes('Số Tiền Gửi') && <div className="vnMoneyTip">{translate("注：如存款金额为50万，请仅输入500")()}</div>}

                {/* {MethodCodeActive === 'INVOICE' && <div className="vnMoneyTip">
                    Tỷ giá hối đoái : 1 USDT-ERC20 = {InvoiceExchangerate?.dynamicObject?.ExchangeRate ?? "XXX,XXX"} đ <br/>
                    Tỷ giá hối đoái này chỉ mang tính chất tham khảo, giao dịch sẽ được tính theo tỷ giá thực tế tại thời điểm thực hiện giao dịch.
                </div>} */}
            </>
        );
    }
}

export default InputItem

